import React from "react";
import { translationLanguages } from "../../utils/list";

function CaptionTranslationPanel({
  show,
  isMobileLike,
  setShowCaptionTranslationPanel,
  translationEnabled,
  setTranslationEnabled,
  stopTranslation,
  startTranslation,
  selectedLanguage,
  changeTranslationLanguage,
  setSelectedLanguage,
  translationStatus,
}) {
  if (!show) return null;

  // Mobile positioning above the bottom bar
  if (isMobileLike) {
    return (
      <>
        {/* Caption Translation Panel */}
        <div
          data-caption-translation-panel
          className="fixed bottom-[5.5rem] left-0 right-0 z-[60] bg-[#001233]/95 backdrop-blur-xl rounded-t-2xl shadow-xl border-t border-white/10 py-4 px-4 max-h-[55vh] overflow-y-auto transition-all duration-300 ease-in-out"
        >
          {/* Close button */}
          <div className="flex justify-end mb-4">
            <button
              onClick={() => setShowCaptionTranslationPanel(false)}
              className="text-gray-400 hover:text-white transition-colors p-1"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          {/* Loading State */}
          {translationEnabled && translationStatus === "starting" && (
            <div className="px-3 py-6">
              <div className="flex flex-col items-center justify-center gap-4">
                {/* Animated Loader */}
                <div className="relative w-12 h-12">
                  <div className="absolute inset-0 border-2 border-[#7700ff]/20 rounded-full"></div>
                  <div className="absolute inset-0 border-2 border-transparent border-t-[#7700ff] rounded-full animate-spin"></div>
                  <div
                    className="absolute inset-1.5 border-2 border-transparent border-r-[#7700ff] rounded-full animate-spin"
                    style={{
                      animationDirection: "reverse",
                      animationDuration: "0.8s",
                    }}
                  ></div>
                </div>
                {/* Loading Text */}
                <div className="text-center">
                  <p className="text-white text-xs font-medium mb-1">
                    Please wait while loading the languages...
                  </p>
                  <p className="text-gray-400 text-[10px]">
                    This may take a few moments
                  </p>
                </div>
              </div>
            </div>
          )}

          {/* Translation Toggle Section */}
          {(!translationEnabled || translationStatus !== "starting") && (
            <div className="space-y-4">
              {/* Toggle Switch */}
              <div className="flex items-center justify-between">
                <span className="text-white text-sm font-medium">
                  Translation
                </span>
                <div className="flex bg-[#1a1a2e] border border-white/30 p-1 rounded-lg">
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      if (translationEnabled) {
                        stopTranslation();
                      }
                      setTranslationEnabled(false);
                    }}
                    className={`px-4 py-1.5 text-xs font-medium transition-all rounded ${
                      !translationEnabled
                        ? "bg-[#7700ff] text-white shadow-sm"
                        : "text-gray-400 hover:text-white"
                    }`}
                  >
                    OFF
                  </button>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      if (!translationEnabled) {
                        startTranslation();
                      }
                      setTranslationEnabled(true);
                    }}
                    className={`px-4 py-1.5 text-xs font-medium transition-all rounded ${
                      translationEnabled
                        ? "bg-[#7700ff] text-white shadow-sm"
                        : "text-gray-400 hover:text-white"
                    }`}
                  >
                    ON
                  </button>
                </div>
              </div>

              {/* Language Selection */}
              {translationEnabled && translationStatus === "started" && (
                <div className="space-y-2">
                  <label className="text-gray-400 text-xs font-medium block">
                    TRANSLATE TO
                  </label>
                  <div className="relative">
                    <select
                      value={selectedLanguage}
                      onChange={(e) => {
                        e.stopPropagation();
                        changeTranslationLanguage(e.target.value);
                        setSelectedLanguage(e.target.value);
                      }}
                      onClick={(e) => e.stopPropagation()}
                      className="w-full bg-[#1a1a2e] border border-white/30 text-white text-sm px-3 py-2.5 pr-8 rounded-lg focus:outline-none focus:border-[#7700ff] appearance-none transition-colors"
                    >
                      {translationLanguages.map((language) => (
                        <option key={language.code} value={language.code}>
                          {language.language}
                        </option>
                      ))}
                    </select>
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"
                    >
                      <path d="M7 10l5 5 5-5z" />
                    </svg>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </>
    );
  }

  // Desktop positioning: absolute dropdown (if needed in future)
  return null;
}

export default CaptionTranslationPanel;
